/**
 * Canal de origen de los eventos de ESTE repo (la SPA legacy).
 *
 * POR QUÉ EXISTE: los dos frontends escriben al MISMO proyecto de Mixpanel, así
 * que sin esta propiedad no hay forma de saber qué tráfico sale de cada uno.
 *
 * Catálogo — mantener sincronizado con `propi-web-nextjs`:
 *   `web-next` → la Next (App Router), en `src/lib/analytics/enrichment.ts`
 *   `web-spa`  → este repo
 */
const CHANNEL_ID = "web-spa";

export const initMixpanel = (): void => {
  const token = process.env.REACT_APP_MIXPANEL_TOKEN;
  if (!token) {
    console.log("Mixpanel token not found, skipping initialization");
    return;
  }
  
  (function (e: Document, c: any) {
    if (!c.__SV) {
      window.mixpanel = c;
      c._i = [];

      c.init = function (q: string, r: any, f?: string) {
        function t(d: any, a: string) {
          const g = a.split(".");
          if (g.length === 2) {
            if (d[g[0]] === undefined) d[g[0]] = [];
            d = d[g[0]];
            a = g[1];
          }

          d[a] = function (...args: any[]) {
            
            d.push([a].concat(args));
          };
        }

        let b = c;
        if (typeof f !== "undefined") b = c[f] = [];
        else f = "mixpanel";

        const methods =
          "disable track track_pageview track_links track_forms register register_once alias identify name_tag set_config reset people.set".split(
            " "
          );

        for (let i = 0; i < methods.length; i++) {
          t(b, methods[i]);
        }

        c._i.push([q, r, f]);
      };

      c.__SV = 1.2;

      const k = e.createElement("script");
      k.type = "text/javascript";
      k.async = true;
      k.src = "https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";

      const s = e.getElementsByTagName("script")[0];
      s.parentNode?.insertBefore(k, s);
    }
  })(document, (window as any).mixpanel || []);

  window.mixpanel.init(token as any, {
    autocapture: true,
    record_sessions_percent: 100,
  });

  // Super property: Mixpanel la inyecta en TODOS los eventos siguientes, sin que
  // ningún caller la pase. Se hace acá y no en un wrapper porque los wrappers no
  // cubren todo: quedan fuera los `window.mixpanel.track(...)` sueltos (Login,
  // VerifyLoginByCode) y los eventos de `autocapture`, que el SDK emite solo.
  //
  // Se registra después del `init` — antes, el stub aún no tiene la cola lista.
  // Sobrevive a toda la sesión porque esta SPA nunca llama `mixpanel.reset()`;
  // si algún día se agrega un reset en el logout, hay que volver a registrarla.
  window.mixpanel.register({ channel_id: CHANNEL_ID });
};